<template>
  <div>
    <div ref="genreListTop" class="absolute target-top"></div>
    <div class="flex justify-center mb-4 fixed w-full backgroundImage z-40 px-2 h-12 pt-2">
      <a class="absolute flex top-4 left-2 text-link text-sm" @click="$emit('close')">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_back') }}</span>
      </a>
      <h1 class="section-title">{{ $t('tour_genre_title') }}</h1>
    </div>
    <div class="px-2 pt-12">
      <div class="bg-white border border-section_border border-b-0 rounded">
        <genre-list-button
          class="ml-4"
          :items="genres"
          :fontWeight="'font-bold'"
          @selectGenre="selectGenre" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GenreListButton from './GenreListButton'

export default {
  components: {
    GenreListButton
  },
  computed: {
    ...mapGetters({
      genres: 'genres/getAllForList'
    })
  },
  mounted () {
    this.$refs['genreListTop'].scrollIntoView({ behavior: 'smooth'})
  },
  methods: {
    selectGenre: function (item) {
      this.$emit('selectGenre', item)
    }
  }
}
</script>
